<template>
  <Modal v-model="shown" :header="false">
    <LoadingSpinner v-if="!eventTypes" />
    <div v-if="eventTypes">
      <h2>Choose event types</h2>
      <div class="input-group">
        <label for="search-field" class="input-group-addon">Search:</label>
        <input type="text" v-model="searchInput" class="form-control" />
      </div>
      <ul class="event-type-list">
        <li v-for="(eventType, index) in searchFilteredEventTypes" :key="index">
          <input type="checkbox" :id="eventType" v-model="selectedEventTypes" :value="eventType" />
          <label :for="eventType">{{ eventType }}</label>
        </li>
      </ul>
    </div>

    <template #footer>
      <div class="controls center-flex">
        <button class="btn btn-default" @click="closeModal" type="button">Cancel</button>
        <button class="btn btn-primary" @click="addSelectedEvents" type="button">OK</button>
      </div>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { Modal } from "uiv";
import LoadingSpinner from "../loading-spinner.vue";

const props = defineProps<{
  eventTypes: string[];
}>();

const emit = defineEmits(["add-selected-events"]);

const selectedEventTypes = ref<string[]>([]);

const shown = ref(false);

const searchInput = ref("");

function openModal(): void {
  shown.value = true;
}

function closeModal(): void {
  shown.value = false;
  searchInput.value = "";
}

function addSelectedEvents(): void {
  emit("add-selected-events", selectedEventTypes.value);
  shown.value = false;
  searchInput.value = "";
}

function clearSelection(): void {
  selectedEventTypes.value = [];
}

const searchFilteredEventTypes = computed(() => {
  if (!props.eventTypes) return [];
  return props.eventTypes.filter((event) => {
    return event.toLowerCase().includes(searchInput.value.toLowerCase());
  });
});

defineExpose({
  openModal,
  closeModal,
  clearSelection,
});
</script>

<style scoped lang="less">
@import (reference) "../../styles/bootstrap/variables";

.input-group {
  margin: 2rem 0;
}

.controls button {
  margin: 0 10px;
}

.event-type-list {
  overflow-y: scroll;
  height: 50rem;
}

ul {
  list-style: none;

  li {
    display: flex;
    margin-bottom: 1rem;
    //vertical-align: middle;
    align-items: center;
  }
}

label {
  font-size: 1.5rem;
  margin-top: 9px;
  margin-left: 1rem;
  cursor: pointer;
  font-weight: normal;
}

input[type="checkbox"] {
  @checkbox-size: 2rem;

  accent-color: @brand-primary;
  width: @checkbox-size;
  height: @checkbox-size;
  cursor: pointer;
  margin: 0;
  flex-shrink: 0;
}
</style>
